document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const selected = select.options[select.selectedIndex];
  const productInfo = select.closest('.product-info');
  const variantInput = productInfo?.querySelector('[data-product-variant-id]');
  const price = productInfo?.querySelector('[data-product-price] span');
  const submitButton = productInfo?.querySelector('.product-form__submit');
  const submitText = productInfo?.querySelector('[data-add-button-text]');
  const available = selected.dataset.available === 'true';

  if (variantInput) variantInput.value = selected.value;
  if (price) price.textContent = selected.dataset.price || '';
  if (submitButton) submitButton.disabled = !available;
  if (submitText) submitText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';

  const url = new URL(window.location.href);
  url.searchParams.set('variant', selected.value);
  window.history.replaceState({}, '', url);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.product-form');
  if (!form || !window.fetch) return;

  const button = form.querySelector('.product-form__submit');
  if (!button || button.disabled) return;

  event.preventDefault();
  button.disabled = true;
  button.classList.add('is-loading');

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add this item.');

    const cartResponse = await fetch(`${root}cart.js`);
    const cart = await cartResponse.json();
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = cart.item_count;
    });
    const text = button.querySelector('[data-add-button-text]');
    if (text) text.textContent = 'ADDED TO CART ✓';
    setTimeout(() => {
      if (text) text.textContent = 'ADD TO CART';
    }, 1800);
  } catch (error) {
    window.alert(error.message);
  } finally {
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});
